import { AuthMethodMode } from './auth-method';
import { AuthRestrictionMode } from './auth-restriction/auth-restriction.i';
import { VisibilityMode } from './visibility/visibility-mode.enum';
var AuthSettingsBuilder = /** @class */ (function () {
    function AuthSettingsBuilder() {
        this.authSettings = {
            method: {
                mode: AuthMethodMode.DEFAULT,
                ssoConfig: {
                    loginUrl: '',
                    logoutUrl: ''
                }
            },
            restrictions: {
                mode: AuthRestrictionMode.NONE,
                allowedDomains: []
            },
            visibility: VisibilityMode.EVERYONE,
            enableHeaderLogin: true,
            enableGuestTickets: true
        };
    }
    AuthSettingsBuilder.prototype.withMethod = function (method) {
        this.authSettings.method = method;
        return this;
    };
    AuthSettingsBuilder.prototype.withRestrictions = function (res) {
        this.authSettings.restrictions = res;
        return this;
    };
    AuthSettingsBuilder.prototype.withVisibility = function (vis) {
        this.authSettings.visibility = vis;
        return this;
    };
    AuthSettingsBuilder.prototype.withHeaderLoginEnabled = function (enabled) {
        this.authSettings.enableHeaderLogin = enabled;
        return this;
    };
    AuthSettingsBuilder.prototype.withGuestTicketsEnabled = function (enabled) {
        this.authSettings.enableHeaderLogin = enabled;
        return this;
    };
    AuthSettingsBuilder.prototype.build = function () {
        return this.authSettings;
    };
    return AuthSettingsBuilder;
}());
export { AuthSettingsBuilder };
//# sourceMappingURL=auth-settings.builder.js.map